import { atom } from "jotai";
import SectionRecord from "models/view-models/section-record";

export const DraggableSection = atom<SectionRecord>();
